import { render, staticRenderFns } from "./PersonCategoryManagement.vue?vue&type=template&id=55606a33&scoped=true"
import script from "./PersonCategoryManagement.vue?vue&type=script&lang=js"
export * from "./PersonCategoryManagement.vue?vue&type=script&lang=js"
import style0 from "./PersonCategoryManagement.vue?vue&type=style&index=0&id=55606a33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55606a33",
  null
  
)

export default component.exports